import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=56cb2692&scoped=true"
import script from "./AuthCallback.vue?vue&type=script&lang=js"
export * from "./AuthCallback.vue?vue&type=script&lang=js"
import style0 from "./AuthCallback.vue?vue&type=style&index=0&id=56cb2692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb2692",
  null
  
)

export default component.exports